import * as React from "react";
const SvgDogecoin = (props) => (
    <img src={'/icon-images-asset/DOGE.png'} alt={'DOGE'} width={'14px'} height={'14px'}/>
);
export default SvgDogecoin;
